module.exports = __webpack_public_path__ + "static/media/arts_18.b29da3fb.jpg";